// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

// IMPORT PROJECT REFERENCES

import { updatePharmacyAliases } from '../State/Actions/PharmacyActions';
import { DeviceSections } from '../DeviceBrowser/DeviceSections';
import { LoadingIndicator } from '../Shared/LoadingIndicator/LoadingIndicator';
import { Error } from '../Shared/Error/Error';
import { DeviceRowType } from '../DeviceBrowser/DeviceRowType';
import { DeviceRow } from '../DeviceBrowser/DeviceRow';
import { DeviceSection } from '../DeviceBrowser/DeviceSection';
import { guid } from '../../Config/Helpers';

// COMPONENT
var editedSections = {};

class DeviceAliases extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aliases: props.aliases,
            editing: props.editing
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }
    
    componentWillReceiveProps(props) {
        this.setState({aliases: props.aliases, editing: props.editing});
    }

    handleUpdate(sections, sectionId, rowId) {
        sections[sectionId].rows[rowId].edited = true
        editedSections = sections;
    }

    saveAliases() {
        let updatedAliases = {};

        Object.keys(editedSections).map(sectionKeys => {
            let section = editedSections[sectionKeys];
            
            Object.keys(section.rows).map(rowKeys => {
                let row = section.rows[rowKeys];
                
                if (row.rowData !== undefined && row.identifier !== undefined && row.edited && row.rowType !== DeviceRowType.NEW) {
                    let alias = {};

                    let dateRange = row.rowData.split("-");
                    let startDate = dateRange[0].trim();
                    let endDate = dateRange[1].trim();

                    alias['name'] = row.rowName;
                    alias['startDate'] = startDate;
                    alias['endDate'] = endDate;
                    
                    updatedAliases[row.dataKey] = alias;
                }
            })
        })

        this.props.updatePharmacyAliases(updatedAliases, this.props.pharmacy);
    }

    newPressed() {
        let newState = Object.assign({}, this.state);
                
        let uid = guid();
        let blankAlias = {startDate: moment().format("DD/MM/YYYY"), endDate: moment().format("DD/MM/YYYY"), name: "", unsaved: true};

        if (!newState.hasOwnProperty('aliases') || newState.aliases === undefined) {
            newState['aliases'] = {};
        }

        newState.aliases[uid] = blankAlias;
        this.setState({aliases: newState.aliases});
    }
    
    generateAliases(aliases) {
        // We have to manually define how the aliases are laid out.
        // 1. Device Info and Events.
        let rows = {};
        let aliasesSection = {};
        let row;

        let hasAliases = false;

        if (aliases !== undefined) {
            Object.keys(aliases).map((aliasKey) => {
                let alias = aliases[aliasKey];
                row = new DeviceRow(alias.name, DeviceRowType.ALIAS, alias.startDate + " - " + alias.endDate, false, false, false, '', true);
                row.dataKey = aliasKey;
                rows[row.uid] = row;
            })
        } else {
            row = new DeviceRow('No aliases', DeviceRowType.EMPTY, null, false, false, false, '', true);
            rows[row.uid] = row;
        }

        if (this.props.editing) {
            row = new DeviceRow('', DeviceRowType.NEW, <button onClick={() => this.newPressed()} type="button" className="btn btn-primary btn-lg btn-block">+ New Alias</button>);
            rows[row.uid] = row;
        }
        
        let section = new DeviceSection("Device Aliases", rows);
        aliasesSection[section.uid] = section;

        
        return aliasesSection;
    }

    render() {
        return (
            <div>
                <DeviceSections editing={this.state.editing} handleUpdate={this.handleUpdate} sections={this.generateAliases(this.state.aliases)} />
            </div>
        );
    }
}

// DeviceAliases.propTypes = {
//     fetchDevices: PropTypes.func.isRequired,
//     fetchedDevice: PropTypes.bool.isRequired,
//     fetchingDevice: PropTypes.bool.isRequired,
//     failedDevice: PropTypes.bool,
//     devices: PropTypes.array.isRequired
// };


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { fetchingDevice, fetchedDevice, failedDevice, device } = state.devicesReducer;
    return { fetchingDevice, fetchedDevice, failedDevice, device };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ updatePharmacyAliases }, dispatch)
);

const hoc = connect(mapStateToProps, mapDispatchToProps)(DeviceAliases);


// EXPORT COMPONENT

export { hoc as DeviceAliases };